import { PathSegment } from '@/models/path-segment';
import { Journey } from '@/models/journey';
import {Mark} from "@/util/markdown";

export enum Alignment {
    left = 'left',
    center = 'center',
    right = 'right'
}

export class HeadlinePathSegment extends PathSegment
{
    public readonly headlineType: string;
    public readonly content: string;
    public readonly alignment: Alignment;

    constructor(title: string,
        alias: string,
        headlineType: string,
        headlineContent: string,
        dataObject?: Journey,
        alignment = Alignment.left)
    {
        super('HeadlinePathSegment', title, alias, 0, undefined, undefined, undefined, dataObject);
        this.headlineType = headlineType;
        this.content = Mark.Down.render(headlineContent);
        this.alignment = alignment;
    }
}
